import React from 'react';
import Text from '../../../Components/Base/Text/Text';
import Collapsible from '../../../Components/Base/Collapsible';
import useTranslation from '../../../Hooks/useTranslation';

const EPrescriptionMedicamentLegend: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Collapsible
			trigger={({ isExpanded }) => (
				<a
					className={`btn-link blue arrow-down ${
						isExpanded ? '' : 'collapsed'
					}`}>
					{t('component.ePrescription.legend')}
				</a>
			)}>
			<table style={{ fontWeight: 'bold' }}>
				<tr>
					<td style={{ color: '#dc3545' }}>
						{t('component.ePrescription.redLabel.title')}
					</td>
					<td>{t('component.ePrescription.redLabel.description')}</td>
				</tr>
				<tr>
					<td style={{ color: '#ffc107' }}>
						{t('component.ePrescription.yellowLabel.title')}
					</td>
					<td>{t('component.ePrescription.yellowLabel.description')}</td>
				</tr>
				<tr>
					<td style={{ color: '#abce42' }}>
						{t('component.ePrescription.greenLabel.title')}
					</td>
					<td>{t('component.ePrescription.greenLabel.description')}</td>
				</tr>
				<tr>
					<td style={{ color: '#1d83b5' }}>
						{t('component.ePrescription.blueLabel.title')}
					</td>
					<td>
						{t('component.ePrescription.blueLabel.description')}
						<span style={{ fontWeight: 'normal' }}>
							{t('component.ePrescription.blueLabel.description2')}
						</span>
					</td>
				</tr>
			</table>
			<Text>
				<div className='d-flex'>
					<img
						src='/dist/icons/vzp-icon.svg'
						alt='VZP Icon'
						style={{ height: 'fit-content' }}
						className='mr-1 mt-1'
					/>
					<div>
						<span>
							<strong>{t('component.ePrescription.list.title')}</strong>
						</span>
						<span>{t('component.ePrescription.list.description')}</span>
					</div>
				</div>
			</Text>
			<Text>
				<div className='d-flex'>
					<img
						src='/dist/icons/warning-triangle.svg'
						alt='Warning icon'
						style={{ height: 'fit-content' }}
						className='mr-1 mt-1'
					/>
					<div>
						<span>
							<strong>{t('component.ePrescription.restrictions.title')}</strong>
						</span>
						<span>{t('component.ePrescription.restrictions.description')}</span>
					</div>
				</div>
			</Text>
			<Text>
				<div className='d-flex'>
					<span
						style={{ height: 'fit-content' }}
						className='doping-icon mr-1 mt-1'></span>
					<span>
						<strong>{t('component.ePrescription.doping')}</strong>
					</span>
				</div>
			</Text>
		</Collapsible>
	);
};
export default EPrescriptionMedicamentLegend;
